__turbopack_context__.v({
  "availability": "ShopItem-module-scss-module__9rYa0q__availability",
  "availabilityInset": "ShopItem-module-scss-module__9rYa0q__availabilityInset",
  "buyButton": "ShopItem-module-scss-module__9rYa0q__buyButton",
  "buyButtonGreen": "ShopItem-module-scss-module__9rYa0q__buyButtonGreen",
  "card": "ShopItem-module-scss-module__9rYa0q__card",
  "cardControls": "ShopItem-module-scss-module__9rYa0q__cardControls",
  "cardHeader": "ShopItem-module-scss-module__9rYa0q__cardHeader",
  "countdown": "ShopItem-module-scss-module__9rYa0q__countdown",
  "description": "ShopItem-module-scss-module__9rYa0q__description",
  "dim": "ShopItem-module-scss-module__9rYa0q__dim",
  "mantine-Badge-label": "ShopItem-module-scss-module__9rYa0q__mantine-Badge-label",
  "mantine-Text-root": "ShopItem-module-scss-module__9rYa0q__mantine-Text-root",
  "newItem": "ShopItem-module-scss-module__9rYa0q__newItem",
  "price": "ShopItem-module-scss-module__9rYa0q__price",
  "sampleWrapper": "ShopItem-module-scss-module__9rYa0q__sampleWrapper",
  "title": "ShopItem-module-scss-module__9rYa0q__title",
  "titleRow": "ShopItem-module-scss-module__9rYa0q__titleRow",
  "type": "ShopItem-module-scss-module__9rYa0q__type",
  "wishlist": "ShopItem-module-scss-module__9rYa0q__wishlist",
});
